'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.parseQuery = parseQuery;
exports.stringifyQuery = stringifyQuery;
exports.uriEncode = uriEncode;
exports.uriDecode = uriDecode;
exports.isAbsolute = isAbsolute;
exports.resolve = resolve;
exports.withQueryParams = withQueryParams;

var _lang = require('./lang');

/**
 * Parse queryString
 * @param  {String} str '?q=query&b=test'
 * @return {Object}
 */
function parseQuery() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : location.search;

  var ret = {};

  if (typeof str !== 'string') {
    return ret;
  }

  var s = str.trim().replace(/^(\?|#|&)/, '');

  if (!s) {
    return ret;
  }

  s.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = parts.shift();
    var val = parts.length > 0 ? parts.join('=') : undefined;

    key = decodeURIComponent(key);

    val = val === undefined ? null : decodeURIComponent(val);

    if (ret[key] === undefined) {
      ret[key] = val;
    } else if (Array.isArray(ret[key])) {
      ret[key].push(val);
    } else {
      ret[key] = [ret[key], val];
    }
  });

  return ret;
}

/**
 * Stringify object to query parammeters
 * @param  {Object} obj
 * @return {String}
 */
function stringifyQuery(obj) {
  var param = [];
  Object.keys(obj).forEach(function (key) {
    var value = obj[key];
    if (value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
      value = JSON.stringify(value);
    }
    param.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
  });
  return param.join('&');
}

function uriEncode(uri) {
  return encodeURIComponent(uri);
}

function uriDecode(uri) {
  return decodeURIComponent(uri);
}

function isAbsolute(url) {
  return (/^(?:\w+:)?\/\//.test(url)
  );
}

function resolve(url) {
  var win = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

  if (isAbsolute(url)) {
    return url;
  }
  var slash = url.charAt(0) === '/' ? '' : '/';
  return '' + win.location.origin + slash + url;
}

function withQueryParams(url, params) {
  var queryStr = (0, _lang.isObject)(params) ? stringifyQuery(params) : params;
  if (queryStr === '') {
    return url;
  }
  var urlSplit = url.split('#');
  var hash = urlSplit[1] ? '#' + urlSplit[1] : '';
  var urlWithoutHash = urlSplit[0];
  return '' + urlWithoutHash + (~urlWithoutHash.indexOf('?') ? '&' : '?') + queryStr + hash;
}